import axios from 'axios'

const API_URL = '/api/barriers/'

//create barrier
const createBarrier = async (barrierData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    const response = await axios.post(API_URL, barrierData, config)
    return response.data
}

//update barrier
const updateBarrier = async (barrierData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }
    
    const response = await axios.put(API_URL+barrierData._id, barrierData, config)
    return response.data

}

//get all barriers for a bowtie
const getBarriers = async (bowtieId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    const response = await axios.get(API_URL+bowtieId, config)
    return response.data
}

//delete barrier (full) or remove from one flowline
const deleteBarrier = async ({ id, threatId, consequenceId }, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        // axios sends this as the request body for DELETE
        data: (threatId || consequenceId) ? { threatId, consequenceId } : undefined,
    }

    const response = await axios.delete(API_URL + id, config)
    return response.data
}

// Add a linked placement to an existing barrier on a new flowline
const addPlacement = async ({ id, threatId, consequenceId, position }, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } }
    const response = await axios.put(API_URL + id, { op: 'addPlacement', threatId, consequenceId, position }, config)
    return response.data
}

// Move a barrier from one flowline to another (removes old placement, adds new one)
const movePlacement = async ({ id, fromThreatId, fromConsequenceId, toThreatId, toConsequenceId, position }, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } }
    const response = await axios.put(API_URL + id, {
        op: 'movePlacement',
        fromThreatId,
        fromConsequenceId,
        toThreatId,
        toConsequenceId,
        position,
    }, config)
    return response.data
}

const barrierService = {
    createBarrier,
    getBarriers,
    updateBarrier,
    deleteBarrier,
    addPlacement,
    movePlacement,
}

export default barrierService